import { render } from "./SelecionarTipoFrete.vue?vue&type=template&id=493bf0ce&ts=true"
import script from "./SelecionarTipoFrete.vue?vue&type=script&lang=ts"
export * from "./SelecionarTipoFrete.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__